<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase>
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.175 3C8.60026 3 10 5.05461 10 5.05461C10 5.05461 11.4025 3 13.825 3C16.3325 3 18.5 4.97601 18.5 7.72524C18.5 11.5691 12.4926 15.9725 10.3341 17.8737C10.143 18.0421 9.85683 18.0423 9.66555 17.8741C7.50509 15.9746 1.5 11.5687 1.5 7.72524C1.5 4.97601 3.6675 3 6.175 3Z"
        fill="currentColor"
      />
      <path
        d="M1.5 7.60809C1.5 5.08674 3.53665 2.99999 6.10811 2.99999C8.09272 2.99999 9.38423 4.25408 10 5.03966C10.6158 4.25408 11.9073 2.99999 13.8919 2.99999C16.4641 2.99999 18.5 5.0868 18.5 7.60809C18.5 11.5 13.0044 15.65 10.3293 17.8763C10.1407 18.0412 9.85926 18.0412 9.67075 17.8763C6.9823 15.65 1.5 11.5 1.5 7.60809ZM6.10811 3.99999C4.09578 3.99999 2.5 5.63216 2.5 7.60809C2.5 10.9 7.70001 14.9969 10 16.8434C12.3 15 17.5 10.9 17.5 7.60809C17.5 5.6321 15.9049 3.99999 13.8919 3.99999C11.9372 3.99999 10.7943 5.58922 10.4987 6.06633C10.2702 6.43521 9.72982 6.43521 9.5013 6.06633C9.20575 5.58921 8.06283 3.99999 6.10811 3.99999Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
